import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';
import Modal from 'patient-ping-remedy/packages/modal';
import Spacer from 'patient-ping-remedy/packages/spacer';
import {css} from '@emotion/css';
import {ClientProfile} from '@/api/dto/client-profile';
import {MessageThreadSummary} from '@/api/dto/message';
import MessageThreadTitle from '@/components/pages/messages/MessageThreadTitle';
import DisplayHelpers from '@/helpers/display_helpers';

type Props = {
  patient: ClientProfile;
  messageThreadSummary: MessageThreadSummary;
  isOpen: boolean;
  close(): void;
  confirm(): void;
}

export default function MessageThreadMuteModal({ messageThreadSummary, patient, isOpen, close, confirm }: Props) {
  const handleConfirm = () => {
    confirm();
    close();
  };

  const title = messageThreadSummary.muted ? 'Unmute' : 'Mute';

  return (
    <Modal
      isOpen={isOpen}
      headerText={`${title} message`}
      buttons={[
        <Button key="cancel" styleType={StyleType.TERTIARY} onClick={close}>Cancel</Button>,
        <Button key="confirm" onClick={handleConfirm}>{title} message</Button>
      ]}
      className={css({ width: '50rem' })}
    >
      <StandardTypography>
        Are you sure you want to {title.toLowerCase()} message{' '}
        <MessageThreadTitle
          messageThread={messageThreadSummary}
          about={DisplayHelpers.formatName(patient.patient.firstName, patient.patient.middleName, patient.patient.lastName)}
        />?
      </StandardTypography>
      <Spacer itemDisplay="block" itemHeight="30px" />
      <StandardTypography>
        {messageThreadSummary.muted
          ? 'You will be notified of new messages in inbox.'
          : 'You no longer will be notified of new messages in inbox, but you can still reply in thread.'}
      </StandardTypography>
    </Modal>
  );
}
